module.exports = __webpack_public_path__ + "static/media/plus-sign-restaurant.9ff44f2d.svg";